import { withInstall } from '@lit-element/utils'

import Col from './src/col.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtCol: SFCWithInstall<typeof Col> = withInstall(Col)
export default LtCol

export * from './src/col'
